import { combineReducers } from 'redux';
import ThemeOptions from './ThemeOptions';
import auth from './auth';

const rootReducer = combineReducers({
  ThemeOptions,
  auth,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
